import previous from "../assets/svg/pre-left.svg";
import next from "../assets/svg/next-right.svg";

const Pagination = ({
  currentPage = 1,
  totalPages = 0,
  recordsPerPage,
  onPageChange,
  onPageSizeChange,
}) => {
  const getVisiblePages = () => {
    const pages = [];
    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages, currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="w-full flex items-center justify-between py-4">
      <div className="flex items-center gap-2 text-sm text-[#172B4D] font-medium">
        <span>Records per page :</span>
        <select
          value={recordsPerPage}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="border border-gray-300 rounded px-2 py-1 text-sm font-bold"
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>

      <div className="flex items-center gap-3 text-sm text-[#172B4D] font-medium">
        <img
          src={previous}
          alt="Previous"
          className={`cursor-pointer ${
            currentPage === 1 && "opacity-40 cursor-not-allowed"
          }`}
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        />

        {currentPage > 3 && (
          <>
            <button onClick={() => onPageChange(1)}>1</button>
            <span>...</span>
          </>
        )}

        {getVisiblePages().map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-9 h-9 rounded-full flex items-center justify-center font-bold
              ${
                currentPage === page
                  ? "bg-[#3D4AF5] text-white"
                  : "hover:text-[#3D4AF5]"
              }`}
          >
            {page}
          </button>
        ))}

        {currentPage < totalPages - 2 && (
          <>
            <span>...</span>
            <button onClick={() => onPageChange(totalPages)}>
              {totalPages}
            </button>
          </>
        )}

        <img
          src={next}
          alt="Next"
          className={`cursor-pointer ${
            currentPage === totalPages &&
            "opacity-40 cursor-not-allowed font-bold"
          }`}
          onClick={() =>
            currentPage < totalPages && onPageChange(currentPage + 1)
          }
        />
      </div>
    </div>
  );
};

export default Pagination;
